import { apiClient } from "@/lib/api-client";

import type { FeedbackItem, FeedbackListResponse } from "./types";

/**
 * Fetch recent feedback across all tenants. The endpoint is operator-gated
 * (ops-portal audience) and returns newest-first, so no client-side sort is
 * needed.
 */
export async function fetchFeedback(): Promise<FeedbackItem[]> {
  const response = await apiClient.get<FeedbackListResponse>("/api/feedback");
  return response.data;
}
